import { memo, useState } from 'react';
import { Handle, Position, Node, NodeProps } from '@xyflow/react';

import { UbiverseEventTopic, UbiverseEventTopicList } from '../../../../types';
import { Button, Select, SelectItem, TextArea } from '@ubiquitel/ui';

import './index.scss';

export type ButtonNodeData = {
  label: string;
  onClick: (topic: UbiverseEventTopic, payload: any) => void;
};
type ButtonNodeProp = Node<ButtonNodeData>;

export default memo(({ data, isConnectable }: NodeProps<ButtonNodeProp>) => {
  const [selectedTopic, setSelectedTopic] = useState<UbiverseEventTopic>(UbiverseEventTopicList.SetPlay);
  const [payload, setPayload] = useState<string>('');

  return (
    <div className="node--button">
      <div className="node--button__header">
        <h6 className="node--button__title">Event Trigger</h6>
      </div>

      <div className="node--button__form-row">
        <Select
          value={selectedTopic}
          onValueChange={(value) => setSelectedTopic(value as UbiverseEventTopic)}
        >
          {Object.keys(UbiverseEventTopicList).map((topicKey) => (
            <SelectItem key={topicKey} value={topicKey}>{topicKey}</SelectItem>
          ))}
        </Select>
      </div>

      <div className="node--button__form-row">
        <TextArea
          label="Payload (JSON)"
          placeholder='{"isPlaying": true}'
          value={payload}
          onChange={(e) => setPayload(e.target.value)}
          className="node--button__textarea"
        />
      </div>

      <Button fullWidth onClick={() => data.onClick(selectedTopic, payload)}>
        {data.label}
      </Button>

      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
      />
    </div>
  );
});
